import {AxiosError} from 'axios';
import {GET_CREATE_AUTHORITY_ACCESS_OPTIONS_KEY} from 'web-library/constants/queryKeys';
import {GET_CREATE_AUTHORITY_ACCESS_OPTIONS_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface CreateAuthorityAccessOptionsResponse {
    showCreateButton: boolean;
}

interface Input {
  onSuccess?: (res: CreateAuthorityAccessOptionsResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  targetAccountType: string;
}

export const useGetCreateAuthorityAccessOptions = ({onError, onSuccess, targetAccountType}: Input) => {

  const getCreateAuthorityAccessOptions = async () => {
    const res = await axiosClient.get<CreateAuthorityAccessOptionsResponse>(GET_CREATE_AUTHORITY_ACCESS_OPTIONS_URL(targetAccountType));

    return res.data;
  };

  return useCustomQuery([GET_CREATE_AUTHORITY_ACCESS_OPTIONS_KEY, targetAccountType], getCreateAuthorityAccessOptions, {
    onSuccess,
    onError,
  }, true, false);
};
